import { render, staticRenderFns } from "./SetAccountPassword.vue?vue&type=template&id=5bc54c6a&"
import script from "./SetAccountPassword.vue?vue&type=script&lang=ts&"
export * from "./SetAccountPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports